import * as React from 'react'
import { cn } from '@/lib/utils'
import { extractMentionUserIdsFromHtml } from '@/shared/utils/mentions'
import { useCommunityMentionUsers } from '@/modules/comunidade/hooks/useCommunityMentionUsers'
import { prepareCommunityMessageContent } from '@/modules/comunidade/utils/communityMessageContent'
import { renderCommunityCustomEmojiTokensInHtml } from '@/modules/comunidade/utils/communityCustomEmojiHtml'
import { renderCommunityMentionsInHtml } from '@/modules/comunidade/utils/communityMentionsHtml'

type PostContentProps = {
  html: string
  className?: string
}

export function PostContent({ html, className }: PostContentProps) {
  const raw = String(html || '').trim()
  const prepared = React.useMemo(() => prepareCommunityMessageContent(raw), [raw])
  const mentionUserIds = React.useMemo(
    () => extractMentionUserIdsFromHtml(prepared.html),
    [prepared.html],
  )
  const mentionUsersById = useCommunityMentionUsers(mentionUserIds)

  const rendered = React.useMemo(() => {
    if (!prepared.text) return ''
    return renderCommunityCustomEmojiTokensInHtml(
      renderCommunityMentionsInHtml(prepared.html, mentionUsersById),
    )
  }, [mentionUsersById, prepared.html, prepared.text])

  if (!rendered) return null

  return (
    <div
      className={cn(
        'prose prose-invert prose-sm max-w-none break-words text-sm text-foreground/80',
        'prose-p:my-0 prose-ul:my-0 prose-ol:my-0 prose-li:my-0',
        'post-content',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: rendered }}
    />
  )
}
